import { createAction, props } from '@ngrx/store';
import { TitleInformation } from '../model/title-information';
import { FormAlert } from '../model/form-alert';
import { ClpInitConfigExtended } from '../model/clpInitConfigExtended.model';

export const updateClpConfig = createAction('[Core Action] CLP config updated', props<ClpInitConfigExtended>());
export const updateTitle = createAction('[Core Action] Title updated', props<TitleInformation>());
export const updateFormAlert = createAction('[Core Action] Raise form alert', props<FormAlert>());
export const clearFormAlert = createAction('[Core Action] Clear form alert');
